app.service('giftCardClientDataView', function (front, broker, orderUtils, validate, permissions, agreementsSubmit) {
	var $self, $form, $phone;
	var isOneInit = false;

	function parsePhoneNo() {
		$phone.val($phone.val().replace(/[^\d-\s]/g, ''));
	}
	function next() {
		if ($form.valid()) {
			orderUtils.send();
		}
	}
	function back() {
		orderUtils.back();
	}
	function setElements() {
		$self = $('#gift-card-client-data #container');
		$form = $('#choose-delivery-form', $self);
		$phone = $('#phone', $self);
	}
	function setEvents() {
		$('.js-delivery-next', $self).click(function () {
			next();
		});
		$('.js-delivery-back', $self).click(function () {
			back();
		});
		//Przy blur inputa z telefonem usuń znaki niedozwolone
		$phone.on('blur', function () {
			parsePhoneNo();
		});

		validate.task('giftCardDelivery');

		$('#phone-country-code-selector').on('change', function() {
			if ($phone.val().length) {
				$form.validate().element($phone);
			}
		});

		$('#permissions-list.old-mode input').click(function () {
			$('#current-permissions-message').addClass('loading');
			setTimeout(function () {
				$('#current-permissions-message').remove();
				$('#permissions-list').removeClass('old-mode');
				$('#permissions-displayed').val('true');
			}, 1000);
		});
	}

	function init() {
		setElements();
		setEvents();
		permissions.init();
		agreementsSubmit.init($form, $('#current-permissions input:checkbox'));
		if (!isOneInit) {
			broker.on('ORDER-NEXT-STEP', function () {
				if(front.page() == 'gift-card-client-data'){
					next();
				}
			});
			isOneInit = true;
		}
	}

	return {
		init: init
	};
});
